var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-cc007f9e"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    className: "dcg-svg-background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "background-images-cc007f9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graphpaper-cc007f9e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "axis-cc007f9e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yaxis-cc007f9e"
  }, /*#__PURE__*/React.createElement("title", null, "tan(q)"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(0,0,0)",
    className: "dcg-svg-axis-line",
    paintOrder: "fill stroke markers",
    d: " M 172 4 L 172 400",
    strokeOpacity: 0.9,
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    className: "dcg-svg-axis-line",
    paintOrder: "stroke fill markers",
    d: " M 172 2 L 176.14110472164032 17.45481322062509 L 167.85889527835968 17.45481322062509 L 172 2 L 176.14110472164032 17.45481322062509",
    strokeOpacity: 0.9,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "",
    fillOpacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xaxis-cc007f9e"
  }, /*#__PURE__*/React.createElement("title", null, "q"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(0,0,0)",
    className: "dcg-svg-axis-line",
    paintOrder: "fill stroke markers",
    d: " M 0 184 L 396 184",
    strokeOpacity: 0.9,
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    className: "dcg-svg-axis-line",
    paintOrder: "stroke fill markers",
    d: " M 398 184 L 382.5451867793749 188.14110472164035 L 382.5451867793749 179.85889527835965 L 398 184 L 382.5451867793749 188.14110472164035",
    strokeOpacity: 0.9,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "",
    fillOpacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 161.3268176114423,
    y: 204.77924293411144,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "0"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 161.3268176114423,
    y: 204.77924293411144,
    textAnchor: "middle"
  }, "0")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(0,0,0)",
    className: "dcg-svg-tickmark",
    paintOrder: "fill stroke markers",
    d: " M 81 180 L 81 188 M 262 180 L 262 188 M 353 180 L 353 188 M 168 328 L 176 328 M 168 40 L 176 40",
    strokeOpacity: 0.9,
    strokeMiterlimit: 2,
    strokeWidth: 2,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 78.16137056001652,
    y: 204.77924293411144,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "-\u03C0"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 78.16137056001652,
    y: 204.77924293411144,
    textAnchor: "middle"
  }, "-\u03C0")), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 262.2852334128681,
    y: 204.77924293411144,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "\u03C0"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 262.2852334128681,
    y: 204.77924293411144,
    textAnchor: "middle"
  }, "\u03C0")), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 352.68212577679384,
    y: 204.77924293411144,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "2\u03C0"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 352.68212577679384,
    y: 204.77924293411144,
    textAnchor: "middle"
  }, "2\u03C0")), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 157.9967394864423,
    y: 333.6503655327594,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "-5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 157.9967394864423,
    y: 333.6503655327594,
    textAnchor: "middle"
  }, "-5")), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-value"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 161.3268176114423,
    y: 45.90812033546348,
    textAnchor: "middle",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 161.3268176114423,
    y: 45.90812033546348,
    textAnchor: "middle"
  }, "5"))), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-label"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Times",
    fontSize: "28px",
    fontStyle: "italic",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 371,
    y: 229.33924293411144,
    textAnchor: "start",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "q"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Times",
    fontSize: "28px",
    fontStyle: "italic",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 371,
    y: 229.33924293411144,
    textAnchor: "start"
  }, "q")), /*#__PURE__*/React.createElement("g", {
    className: "dcg-svg-axis-label",
    transform: "translate(139.1051379239423,77.6953125) rotate(-90,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "none",
    stroke: "#ffffff",
    fontFamily: "Arial",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 0,
    y: 0,
    textAnchor: "start",
    strokeMiterlimit: 2,
    strokeWidth: 3,
    strokeDasharray: ""
  }, "tan(q)"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "none",
    fontFamily: "Arial",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "normal",
    x: 0,
    y: 0,
    textAnchor: "start"
  }, "tan(q)")))), /*#__PURE__*/React.createElement("g", {
    id: "expressions-cc007f9e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sketch-cc007f9e"
  }, /*#__PURE__*/React.createElement("title", null, "Expression 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#c74440",
    stroke: "none",
    paintOrder: "stroke fill markers",
    d: "",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74440",
    className: "dcg-svg-curve",
    paintOrder: "fill stroke markers",
    d: " M -2.842170943040401e-14 175.1381253079317 L -2.842170943040401e-14 175.1381253079317 L 3.8085937499999716 170.72763209029094 L 7.031249999999972 166.54470781488936 L 9.863281249999972 162.3614516448759 L 12.20703125 158.3948192237333 L 14.2578125 154.41424740127573 L 16.11328125 150.26813258882265 L 17.7734375 145.98282998946507 L 19.33593749999997 141.30034004008593 L 20.703125 136.53193162534237 L 21.97265624999997 131.37666081348374 L 23.2421875 125.30942747333756 L 24.4140625 118.64513756098813 L 25.48828124999997 111.34603901868671 L 26.46484374999997 103.39781602117682 L 27.44140625 93.77107982759215 L 28.32031249999997 83.1614941197728 L 29.19921874999997 69.99776588396159 L 29.98046875 55.289558613540464 L 30.76171874999997 36.50151590732398 L 31.4453125 15.164281776222992 L 32.005501647861614 -8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74440",
    className: "dcg-svg-curve",
    paintOrder: "fill stroke markers",
    d: " M 39.99750926605713 408 L 39.99750926605713 408 L 40.234375 393.0917446975076 L 40.91796874999997 361.8137449894757 L 41.60156249999997 338.53190717501286 L 42.3828125 318.26082603631187 L 43.26171875 300.8176078670293 L 44.14062499999997 287.2143597085669 L 45.11718749999996 275.20728092548336 L 46.093749999999986 265.52563955094934 L 47.16796874999997 256.8133793800598 L 48.339843749999986 249.0039647536155 L 49.511718749999986 242.50486646014858 L 50.781249999999986 236.57291105289596 L 52.148437499999986 231.16298974786218 L 53.613281249999986 226.2240595566206 L 55.175781249999986 221.70367792127706 L 56.933593749999986 217.32383100948385 L 58.789062499999986 213.3205369271704 L 60.9375 209.2883632548913 L 63.281249999999986 205.44548005585202 L 66.01562499999999 201.50284729601506 L 69.23828124999999 197.39104617636542 L 73.04687499999997 193.0349109841781 L 78.02734374999999 187.82018119366126 L 91.01562499999999 174.45129721979924 L 94.72656249999999 170.08437095682578 L 97.85156249999999 165.9539350729516 L 100.58593749999999 161.8411178490283 L 102.92968749999999 157.7980984335888 L 104.98046875 153.72803304471032 L 106.83593749999999 149.47496283652725 L 108.49609375 145.06430745302356 L 109.96093749999999 140.55302087144952 L 111.328125 135.66267468601376 L 112.59765624999999 130.360903736461 L 113.76953124999997 124.6235774389917 L 114.94140625 117.82622726805998 L 116.01562499999999 110.36482410723592 L 116.99218749999999 102.22009117202327 L 117.96875 92.32763396948633 L 118.84765625 81.38987353765474 L 119.72656249999997 67.76720081325003 L 120.5078125 52.4779717029235 L 121.28906249999999 32.84220853006255 L 121.97265624999999 10.39739001989102 L 122.40230487385575 -8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74440",
    className: "dcg-svg-curve",
    paintOrder: "fill stroke markers",
    d: " M 130.3946973360172 408 L 130.3946973360172 408 L 130.6640625 391.3472747567723 L 131.34765625 360.54229086894406 L 132.12890625 334.7473634272478 L 132.91015625 315.3656370334162 L 133.7890625 298.5903882372653 L 134.66796875 285.44508830429174 L 135.64453125 273.796064876276 L 136.62109375 264.3714407778766 L 137.6953125 255.8661623476164 L 138.8671875 248.22263417234117 L 140.0390625 241.84737840941588 L 141.30859375 236.0171543533221 L 142.67578124999997 230.69057941073487 L 144.140625 225.81986223138696 L 145.703125 221.3553076523838 L 147.4609375 217.02351747327276 L 149.4140625 212.86465719942134 L 151.5625 208.89148364355233 L 154.00390625 204.94854772352224 L 156.8359375 200.9337273534739 L 160.15625 196.76781106175386 L 164.0625 192.36392824054627 L 169.3359375 186.8983621416917 L 180.6640625 175.2809070888194 L 184.5703125 170.76685297642598 L 187.79296875 166.58900667140185 L 190.625 162.4121815141315 L 192.96875 158.45289592497963 L 195.01953125 154.4809182401452 L 196.875 150.34505538785817 L 198.53515625 146.07174271101744 L 200.09765625 141.40397302941167 L 201.5625 136.28434395122977 L 202.83203125 131.0876439017826 L 204.1015625 124.966189606202 L 205.27343749999997 118.23552597073696 L 206.34765624999997 110.85552933854548 L 207.32421875 102.80944420155734 L 208.30078124999997 93.05051303954345 L 209.1796875 82.27785455483875 L 210.05859375 68.88639296192184 L 210.83984375 53.89035387616997 L 211.62109375 34.68320590832681 L 212.3046875 12.799721900758357 L 212.79318770284397 -8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74440",
    className: "dcg-svg-curve",
    paintOrder: "fill stroke markers",
    d: " M 220.79044282134788 408 L 220.79044282134788 408 L 220.99609375 394.82554967636617 L 221.67968749999997 363.0743337317998 L 222.36328125 339.490496612121 L 223.14453125 318.9912867295543 L 224.0234375 301.37764606987844 L 224.90234375 287.65807486663584 L 225.87890625 275.560375737812 L 226.85546875 265.8138843117937 L 227.9296875 257.0495328391413 L 229.1015625 249.19846460233532 L 230.27343749999997 242.66833052031186 L 231.54296875 236.71092301452694 L 232.91015625 231.28018038784506 L 234.375 226.32423197123794 L 235.9375 221.7899384754837 L 237.6953125 217.39812851802176 L 239.55078125 213.38520467074713 L 241.69921875 209.34459083826394 L 244.04296875 205.49483917253926 L 246.77734375 201.5463513848729 L 250 197.42972920672617 L 253.80859374999997 193.0699172516662 L 258.7890625 187.85272084942198 L 271.875 174.37790392179414 L 275.5859375 170.00259067720884 L 278.7109375 165.86143216812025 L 281.4453125 161.73524049360077 L 283.7890625 157.676447381157 L 285.83984375 153.58787029160317 L 287.6953125 149.31263118631222 L 289.35546875 144.87593302772493 L 290.8203125 140.33479095534088 L 292.1875 135.40840008141328 L 293.45703125 130.06322119898658 L 294.62890625 124.27383839337989 L 295.80078125 117.40796675561383 L 296.875 109.86278471802137 L 297.8515625 101.61635109934241 L 298.828125 91.58595301614062 L 299.70703125 80.47722470558622 L 300.5859375 66.61444587369105 L 301.3671875 51.01972510185976 L 302.05078125 33.75778770289821 L 302.734375 11.593179135775586 L 303.1877789033891 -8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74440",
    className: "dcg-svg-curve",
    paintOrder: "fill stroke markers",
    d: " M 311.18819925025286 408 L 311.18819925025286 408 L 311.42578125 393.0526451197111 L 312.109375 361.78528155759057 L 312.79296875 338.5102426331927 L 313.57421875 318.2443039707202 L 314.453125 300.8049317384281 L 315.33203125 287.2043110467325 L 316.30859375 275.1992806929079 L 317.28515625 265.5191061428204 L 318.359375 256.80802482996864 L 319.53125 248.9995532907101 L 320.703125 242.50115796508132 L 321.97265625 236.5697792500852 L 323.33984375 231.16032985683353 L 324.8046875 226.22178548486096 L 326.3671875 221.701719319499 L 328.125 217.32214374332972 L 329.98046875 213.31906811589218 L 332.12890625 209.28708594244875 L 334.47265625 205.44435860235944 L 337.20703125 201.50185871597517 L 340.4296875 197.39016700603838 L 344.23828125 193.03411524029926 L 349.21875 187.81944136665624 L 362.20703125 174.4504819498145 L 365.91796875 170.0834628333038 L 369.04296875 165.9529082135252 L 371.77734375 161.83994290128393 L 374.12109375 157.7967488694975 L 376.171875 153.72647861362407 L 378.02734375 149.47316314953403 L 379.6875 145.06221976688502 L 381.15234375 140.5506031650674 L 382.51953125 135.65985873393254 L 383.7890625 130.35760843987006 L 384.9609375 124.61970763310049 L 386.1328125 117.82160175948586 L 387.20703125 110.35927535761853 L 388.18359375 102.21342266683322 L 389.16015625 92.31944825315267 L 390.0390625 81.3798095936471 L 390.91796875 67.75450285433263 L 391.69921875 52.46192807806534 L 392.48046875 32.82126394935469 L 393.1640625 10.370011239299515 L 393.59293082149196 -8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: ""
  })))), /*#__PURE__*/React.createElement("g", {
    id: "labels-cc007f9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.59f794f34a0f8524b4e2df4124843dc0.svg";
export { ForwardRef as ReactComponent };